export default __webpack_public_path__ + "static/media/CarGray.0eb3dde4.png";